module.exports = __webpack_public_path__ + "img/demo6.0d3d7977.png";